import * as React from 'react'
import { useParams } from 'react-router-dom'
import { GroupedOrderList } from './Delivered/DeliveredGroupedOrder'
import PageNotFound from '../../../page-not-found/PageNotFound'
import { useReportStoreBackoffice } from '../../../../hooks/useReportStoreBackoffice'

type RootStore = {
	login: (cookie?: string) => Promise<void>
}

export function PreviewGroupOrderBackoffice<T extends RootStore>() {
	const [store, setCookieData, login] = useReportStoreBackoffice()
	const { companyId, groupId } = useParams()
	const [loggedIn, setLoggedIn] = React.useState(false)
	
	React.useEffect(() => {
		window.addEventListener("message", handleMessage);
		return () => window.removeEventListener("message", handleMessage);
	},[])

	const handleMessage = (ev: MessageEvent) => {
		if (ev.type == 'message' && ev.data.type == 'cookie') {
			const cookieValue = ev.data.cookie
			if (cookieValue) {
				setCookieData(cookieValue)
				login();
				setLoggedIn(true)
			}
		}
	}

	return loggedIn ? (
		<GroupedOrderList
			groupId={groupId}
			companyId={companyId}
			hideBackButton={true}
			backoffice={true}
		/>
	) : (
		<PageNotFound />
	)
}

export default PreviewGroupOrderBackoffice
